import {useEffect, useMemo, useRef, useState} from 'react';
import {Animated} from 'react-native';

import {useTranslation} from '/provider/TranslationProvider';

import {NO_VALUE} from '../Bonuses.hook';

import {PIE_CHART_HEIGHT, PIE_CHART_MARGIN} from './PieChart.style';
import {UsePieChartProps} from './PieChart.types';
import {countPercent, getFormattedItemsForPie} from './PieChart.util';

export const usePieChart = ({
  data,
  totalBonus,
  selectedTileIndex,
}: UsePieChartProps) => {
  const {tt} = useTranslation('bonusesPage.pieChart');

  const [innerTextHeight, setInnerTextHeight] = useState(0);
  const pieCenter = useMemo(
    () => (PIE_CHART_HEIGHT - PIE_CHART_MARGIN) / 2,
    [],
  );
  const marginTop = pieCenter - innerTextHeight / 2;

  const marginAnimation = useRef(new Animated.Value(pieCenter)).current;

  const {bonusAmount, bonusDescription} = data[selectedTileIndex] || {
    bonusAmount: 0,
    bonusDescription: '',
  };
  const percent =
    selectedTileIndex !== NO_VALUE &&
    countPercent({
      value: bonusAmount,
      total: totalBonus,
    });

  const formattedItemsForPie = useMemo(
    () =>
      getFormattedItemsForPie({
        data,
        total: totalBonus,
      }),
    [totalBonus, data],
  );

  useEffect(() => {
    Animated.timing(marginAnimation, {
      toValue: marginTop,
      duration: 500,
      useNativeDriver: false,
    }).start();
  });

  const onLayout = ({
    nativeEvent: {
      layout: {height},
    },
  }: any) => {
    setInnerTextHeight(height);
  };

  return {
    tt,
    onLayout,
    formattedItemsForPie,
    marginAnimation,
    percent,
    bonusDescription,
  };
};
